export default __webpack_public_path__ + "static/media/drew_wilenzick.ac0dd99a.jpg";